import { render } from "./ReturnsPortal.vue?vue&type=template&id=284aa2ee&scoped=true"
import script from "./ReturnsPortal.vue?vue&type=script&lang=js"
export * from "./ReturnsPortal.vue?vue&type=script&lang=js"

import "./ReturnsPortal.vue?vue&type=style&index=0&id=284aa2ee&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-284aa2ee"]])

export default __exports__